import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, TemplateRef } from '@angular/core';
import iconLibrary from 'src/app/common/iconLibrary';
import { ErrorMessageComponent } from '../../error-message/error-message.component';

@Component({
  selector: 'wct-error',
  standalone: true,
  imports: [CommonModule, ErrorMessageComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ErrorComponent {
  @Input({ required: true }) public set error(value: Error | string) {
    this.errorMessage = typeof value === 'string' ? value : value.message;
  }

  @Input({ required: true }) public template!: TemplateRef<unknown>;

  protected errorMessage: string = "";

  protected readonly iconLibrary = iconLibrary;
}
